import styled from "@emotion/styled";
import { Card, Col, DatePicker, Form, Input, Row, Tabs, Typography } from "antd";
import { goBack, chat, search } from "assets/icons/index";
import { useNavigate } from "react-router-dom";
import {
  useGetCancelOrder,
  useGetCompleteOrder,
} from "hooks/useOrders";
import FinishOrderTable from "./FinishOrderTable";
import { useState } from "react";
import Item from "antd/es/list/Item";

const OrderCard = () => {
  const navigate = useNavigate();

  const [searchValue, setSearchValue] = useState("");
  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);

  // const { data: dataCancel, refetch: refectchCancel } = useGetCancelOrder({
  //   limit: 0,
  //   offset: 0,
  //   search: searchValue,
  //   order_status: "cancel",
  //   sort_by: "desc",
  //   start_date: startDate || undefined,
  //   end_date: endDate || undefined,
  // });

 const [limitComplete, setLimitComplete] = useState(10);
 const [offsetComplete, setOffsetComplete] = useState(0);

  const { data: dataComplete, isLoading: isLoadingComplete } = useGetCompleteOrder({
    limit: limitComplete,
    offset: offsetComplete,
    search: searchValue,
    order_status: "complete",
    sort_by: "desc",
    start_date: startDate || undefined,
    end_date: endDate || undefined,
  });

  const items = [
    // {
    //   // (${inprosessItems?.length || 0})
    //   label: `กำลังการผลิต`,
    //   key: "1",
    //   children: <ReceiveOrderTables refectchNewOrderSku={refectchNewOrderSku} />,
    // },
    // {
    //   label: `รอจัดส่ง`,
    //   key: "2",
    //   children: <WaitingSendOrderTables 
    //     data={dataNewOrderSku} 
    //     refetch={refectchNewOrderSku} 
    //     offset={offsetWaitDC}
    //     limit={limitWaitDC}
    //     handleSetOffset={handleSetOffset} 
    //     handleSetLimit={handleSetLimit} />,
    // },
    // {
    //   label: `ระหว่างจัดส่ง`,
    //   key: "5",
    //   children: <InprocessDeliveryTabsCard/>,
    // },
    {
      label: `ประวัติคำสั่งซื้อ`,
      key: "0",
      // children: <FinishTabsCard data={dataComplete} />,
      children: <FinishOrderTable data={dataComplete?.data} limit={limitComplete}  setLimit={setLimitComplete} setOffset={setOffsetComplete} offset={offsetComplete} isLoading={isLoadingComplete} />,
    },
    // {
    //   //(${requestCancelItems?.length || 0})
    //   label: `คำขอร้องยกเลิก`,
    //   key: "7",
    //   children: <WaitingRefundTabsCard data={dataOrderWaitingRefund} refetch={refectchOrderWaitingRefund} refetchTo={refectchCancel} />,
    // },
    // {
    //   label: `ยกเลิก`,
    //   key: "9",
    //   // children: <CancelTabsCard data={dataCancel} />,
    //   children: <CancelOrderTable data={dataCancel?.data}/>,
    // },
    // {
    //   label: `คืนเงิน/สินค้า`,
    //   key: "10",
    //   children: <ReturnTabsCard />,
    // },
  ];

  return (
    <Row className="rowgap-vbox" gutter={[24, 0]}>
      <Col span={24}>
        <Card bordered={false} className="criclebox h-full tabs-mobile">
          <HeaderTabs>
            <IconWrapper
              onClick={() => {
                navigate("/dashboard");
              }}

              style={{ width: 50 }}
            >
              <SpanIcon>{goBack}</SpanIcon>
            </IconWrapper>
            <Typography.Title level={5}>คำสั่งซื้อ</Typography.Title>
            <RightIconWrapper>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>

                <Typography.Text style={{ width: 40, }}>เริ่มต้น</Typography.Text>
                <DatePicker onChange={(value) => {
                  if (value) {
                    setStartDate(value.format("YYYY-MM-DD"));
                  }else{
                    setStartDate(null);
                  }
                }}
                  style={{ width: 150 }}
                />

                <Typography.Text style={{ width: 40, marginLeft: 10 }}>สิ้นสุด</Typography.Text>
                <DatePicker onChange={(value) => {
                  if (value) {
                    setEndDate(value.format("YYYY-MM-DD"));
                  }else{
                    setEndDate(null);
                  }
                }}
                  style={{ marginLeft: 10, width: 150 }}
                  
                />
              </div>


              <Input placeholder="ค้นหาคำสั่งซื้อ"
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
                size="small"
                style={{ marginLeft: 10, width: 200 }}
              />
              <IconWrapper
                style={{ width: 50 }}
              >
                <SpanIcon>{search}</SpanIcon>
              </IconWrapper>
            </RightIconWrapper>
          </HeaderTabs>
          <div>
            <Tabs
              defaultActiveKey="0"
              style={{ height: "100%" }}
              items={items}
              key="key"
            />
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default OrderCard;

const HeaderTabs = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-direction: row;
`;

const IconWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 30px;
  border-radius: 6px;
  background-color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  &:hover {
    background-color: #efefef;
  }
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const RightIconWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 700px;
`;
